import * as React from "react";

export default function NotificationHeader({
  unreadCount,
  totalCount,
  allRead,
  markingAll,
  deletingAll,
  filter,
  setFilter,
  onMarkAll,
  onDeleteAll,
  setDeleteConfirm,
}) {
  return (
    <div className="nh-header">
      <div className="nh-top">
        <div className="nh-title-wrap">
          <div className="nh-title-row">
            <h1 className="nh-title">Notifications</h1>
            {unreadCount > 0 && (
              <span className="nh-badge">{unreadCount}</span>
            )}
          </div>
          <p className="nh-subtitle">
            {totalCount === 0
              ? "No notifications"
              : `${totalCount} total · ${unreadCount} unread`}
          </p>
        </div>

        {totalCount > 0 && (
          <div className="nh-actions">
            {!allRead && (
              <button
                className="nh-btn nh-btn--ghost"
                onClick={onMarkAll}
                disabled={markingAll}
              >
                {markingAll ? (
                  <span className="nh-spin" />
                ) : (
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                )}
                Mark all read
              </button>
            )}
            {/* <button
              className="nh-btn nh-btn--danger"
              onClick={() => setDeleteConfirm("all")}
              disabled={deletingAll}
            >
              {deletingAll ? (
                <span className="nh-spin" />
              ) : (
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="3 6 5 6 21 6" />
                  <path d="M19 6l-1 14H6L5 6" />
                  <path d="M10 11v6M14 11v6" />
                  <path d="M9 6V4h6v2" />
                </svg>
              )}
              Clear all
            </button> */}
          </div>
        )}
      </div>

      {/* Filter Tabs */}
      {totalCount > 0 && (
        <div className="nh-tabs">
          {["all", "unread", "read"].map((tab) => (
            <button
              key={tab}
              className={`nh-tab ${filter === tab ? "nh-tab--active" : ""}`}
              onClick={() => setFilter(tab)}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}